import { MapPin, Phone, Mail } from 'lucide-react';
import { Logo } from './Navbar';

export const Footer = () => {
  return (
    <footer className="bg-[#0B3D2E] py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-8">
          <div>
            <Logo size="md" />
            <p className="text-white/60 text-sm font-light mt-4">Your trusted partner in finding luxury properties across Bangalore.</p>
          </div>
          <div>
            <h3 className="text-white font-heading text-lg mb-4">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-white/60 text-sm"><Phone size={16} className="text-brand-gold" /><span>+91 918 710 8123</span></div>
              <div className="flex items-center gap-3 text-white/60 text-sm"><Mail size={16} className="text-brand-gold" /><span>shekar@thenrirealtor.com</span></div>
              <div className="flex items-center gap-3 text-white/60 text-sm"><MapPin size={16} className="text-brand-gold" /><span>Bangalore, Karnataka</span></div>
            </div>
          </div>
          <div>
            <h3 className="text-white font-heading text-lg mb-4">Quick Links</h3>
            <div className="space-y-2">
              <a href="#builders" className="block text-white/60 text-sm hover:text-brand-gold transition-colors">Popular Projects</a>
              <a href="#services" className="block text-white/60 text-sm hover:text-brand-gold transition-colors">Our Services</a>
              <a href="#enquiry" className="block text-white/60 text-sm hover:text-brand-gold transition-colors">Enquiry</a>
            </div>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 text-center">
          <p className="text-white/40 text-sm">2026 The NRI Realtor. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
